module.exports = __webpack_public_path__ + "static/media/Discovery-BM.ddd24145.svg";